<template>
    <div class="store" ref='store' :class="{displaySettings:openSettings,open:openStore}">
        <div class="blackout" @click.stop.prevent="toggleSettings"/>

        <div class="content" :class="{transition:transition}">
            <div class="click-options" v-if="!openSettings">
                <div class="option" @click.stop.prevent="toggleSettings">
                    <awesome-icon icon="cog"/>
                    <span class="option-label">Settings</span>
                </div>
                <div class="option" @click.stop.prevent="handleStoreClick">
                    <awesome-icon icon="external-link-alt"/>
                    <span class="option-label">View TL</span>
                </div>
            </div>
            <div class="close-settings" v-else @click.stop.prevent="toggleSettings">
                <awesome-icon icon="times"/>
            </div>

            <div class="flex" :class="{closed: !isOpen}">
                <div class="info">
                    <div class="info-store">
                        <template v-if="!openSettings">
                            <div class="location">
                                <span class="label">Location:</span>
                                <div style="height: .25em;"/>
                                <span class="name">
                                {{ store.name }}
                            </span>
                            </div>

                            <div class="location" :style="occupancyStyle" v-if="isOpen">
                                <span class="label">Occupancy:</span>
                                <span class="name" style="font-weight: bold;"> {{ occupancy || 0 }}</span>
                            </div>
                            <div class="closed-indicator location" v-else>
                                <span class="label">CLOSED</span>
                            </div>
                        </template>

                        <template v-else>
                            <div class="location">
                                <div class="line">
                                    <span class="label">Location:</span>
                                    <span class="name">{{ store.name }}</span>
                                </div>
                                <div class="line" :style="occupancyStyle">
                                    <span class="label">Occupancy:</span>
                                    <span class="name" style="font-weight: bold;">{{ occupancy || 0 }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                    <store-item-counters :id="store.id" :open="openSettings"/>
                </div>

                <transition name="slide" appear>
                    <div class="settings">
                        <store-item-settings v-if="openSettings" :id="store.id" @fetch="fetch" :canmanage="canManage"/>
                    </div>
                </transition>

            </div>

            <StoreItemOccupancyHistory :id="store.id" :limit="limit" v-if="limit > 0"
                                       @updateOccupancy="updateOccupancy" :open="openSettings" class="history"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import StoreItemSettings from './StoreItemSettings';
import StoreItemCounters from './StoreItemCounters';
import StoreItemOccupancyHistory from './StoreItemOccupancyHistory';

export default {
  name: 'store-item',
  components: {StoreItemOccupancyHistory, StoreItemCounters, StoreItemSettings},
  props: {
    store: {}
  },
  data() {
    return {
      canManage: false,
      openSettings: false,
      openStore: false,
      transition: false,
      boundingRect: undefined,
      parentRect: undefined,
      limit: 0,
      occupancy: undefined,
      isOpen: true
    };
  },

  mounted() {
    this.fetch();
  },

  computed: {
    warn() {
      return this.occupancy > ((this.limit / 100) * 90);
    },

    storeStyle() {
      let color = this.occupancy > this.limit ? '#E2574E' : '#EFB06A';

      if (this.occupancy <= 2 || this.warn) {
        return {
          boxShadow: '0 0 10px 1px ' + color
        };
      }

      return {};
    },

    occupancyStyle() {
      let color = this.occupancy > this.limit ? '#E2574E' : '#EFB06A';
      if (this.occupancy < 0 || this.warn) {
        return {
          color: color
        };
      }
      return {};
    }
  },
  methods: {
    fetch() {
      axios.get(`${process.env.VUE_APP_API_BASE}/user-customer-features?customer_id=${this.store.customer}&api_key=${this.$store.getters['key']}`)
        .then((res) => {
          this.canManage = res.data.find(feature => feature.slug === 'occupancy-admin');
        });

      axios.get(`${process.env.VUE_APP_API_BASE}${process.env.VUE_APP_ENDPOINT_STORE_LIMIT}?api_key=${this.$store.getters.key}&format=json&site_id=${this.store.id}`)
        .then((res) => {
          this.limit = res.data.results.find((l) => l.end_time === null).limit;
        });

      this.fetchOccupancy();
    },

    fetchOccupancy() {

      axios.get(`${process.env.VUE_APP_API_BASE}/b/v1/intellicount/report/latest/?site_id=${this.store.id}&api_key=${this.$store.getters.key}`)
        .then((res) => {
          if (res.status === 200) {
            this.occupancy = res.data.count.sum;
          }
        });
    },

    handleStoreClick() {
      this.viewStore();
    },

    viewStore() {
      this.$emit('select', this.store.id);
    },

    toggleSettings() {
      if (this.openSettings) {
        this.openSettings = false;
        this.parentRect = undefined;
        this.boundingRect = undefined;
        setTimeout(() => {
          this.transition = false;
        }, 300);

      } else {
        this.openSettings = true;
        this.transition = true;

        this.parentRect = this.$refs.store.parentElement.getBoundingClientRect();
        this.boundingRect = this.$refs.store.getBoundingClientRect();
      }
    },

    updateOccupancy(counts) {
      this.fetchOccupancy();
      if (counts === 0) {
        this.isOpen = false;
      } else {
        this.isOpen = true
      }
    }
  }
};
</script>

<style scoped lang="scss">
.store {
    width: 100%;
    height: inherit;
    min-width: 300px;
    position: relative;
    flex: 1;
    align-items: flex-start;
    transition: all cubic-bezier(.25, .8, .25, 1) .3s;

    .blackout {
        position: fixed;
        background: black;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        pointer-events: none;
        transition: all cubic-bezier(.25, .8, .25, 1) .3s;
        z-index: 1;
    }

    &:hover {
        &:not(.displaySettings) {
            .click-options {
                opacity: .9;
            }
        }

        .content {
            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.22);
        }
    }

    .click-options {
        opacitY: 0;
        background: #FFF;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        display: flex;
        padding: 1em;
        transition: all cubic-bezier(.25, .8, .25, 1) .3s;

        .option {
            flex: 1;
            display: flex;
            justify-content: center;
            flex-flow: column;
            align-items: center;
            font-size: 2em;
            background: #FFF;
            cursor: pointer;
            opacity: .75;
            transition: all cubic-bezier(.25, .8, .25, 1) .3s;

            .option-label {
                margin-top: 1em;
                font-size: .75em;
                //display: none;
            }

            &:first-child {
                border-right: 1px solid grey;
            }

            &:last-child {
                border-left: 1px solid grey;
            }

            &:hover {
                opacity: 1;

                svg {

                    animation: pulse 1s infinite;
                }
            }
        }
    }

    .content {
        transition: box-shadow cubic-bezier(.25, .8, .25, 1) .3s;
        background: #FFF;
        box-shadow: var(--shadow);
        border-radius: .5em;
        width: inherit;
        padding: 1em 1.25em;
        position: relative;
        top: 0;
        left: 0;
        cursor: pointer;
        overflow: hidden;
        display: flex;
        flex-flow: column;

        &.transition {
            z-index: 3;
            position: absolute;
        }

        .flex {
            flex: 1;
            position: relative;
            display: flex;
            justify-content: space-between;
            width: 100%;

            .info {
                flex: 1;
                display: flex;
                flex-flow: row;
                justify-content: space-between;
                background: #FFF;

                .info-store {
                    flex: 1;

                    .location {
                        margin-bottom: .5em;
                        flex: 1;

                        .label {
                            color: #929293;
                        }
                    }
                }
            }
        }
    }

    &.displaySettings {
        position: fixed;
        top: 2em;
        left: 0;
        right: 0;
        z-index: 4;
        display: flex;
        align-items: center;
        justify-content: center;
        height: auto;

        .blackout {
            opacity: .5;
            pointer-events: initial;
            z-index: 3;
        }

        .content {
            cursor: default;
            padding: 0;
            box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
            min-width: 320px;
            max-width: 1200px;
            height: 100%;
            max-height: 90vh;
            position: relative;
            background: #eaeaea;

            .close-settings {
                position: fixed;
                background: #FFF;
                top: 0;
                right: 0;
                font-size: 1.25em;
                border-bottom-left-radius: 1em;
                width: 60px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
                cursor: pointer;
                opacity: .75;
                z-index: 3;

                &:hover {
                    opacity: 1;
                }
            }

            .flex {
                .settings {
                    flex: 2;
                    margin: 1em 1em 1em 0;
                }

                .info {
                    margin: 1em;
                    padding: 1em;
                    flex: 1;
                    flex-flow: column;
                    border-radius: .5em;
                    box-shadow: var(--shadow);

                    .line {
                        display: flex;
                        margin-bottom: .5em;

                        .label {
                            width: 200px;
                            margin-right: 1.5em;
                        }
                    }
                }
            }

            .history {
                min-height: 360px;
            }
        }
    }

    .closed-indicator {
        width: 100%;
        font-size: .75em;
    }
}


@media only screen and (min-width: 1024px) and (max-width: 1280px) {
    .store.displaySettings {
        .content {
            max-width: 1000px;

            .flex {
                .info {
                    .line {
                        .label {
                            width: 120px;
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 1024px) {
    .store {
        &.displaySettings {

            .content {
                max-width: 768px;
                overflow-y: auto;

                .flex {
                    flex-flow: column;

                    .settings {
                        margin: 0 1em 1em 1em;
                    }
                }
            }
        }
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

@media only screen and (max-width: 720px) {
    .store {
        .content {
            overflow: hidden;

            .flex.closed {
                margin-bottom: 2em;
            }

            .info {

            }

            .settings.closed {
                margin-top: 5em;
            }

        }

        .chart {
            margin: 0 auto 3em;
            //margin-bottom: 4em;
        }

        .click-options {
            opacity: 1 !important;
            top: initial;
            padding: 0;
            bottom: 0;
            position: absolute;
            background: transparent;
            box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.24);
            overflow: hidden;

            .option {
                opacity: 1;
                font-size: 1em;
                z-index: 5;
                height: 3em;
                padding: .25em;
                border-left: none !important;
                flex-flow: initial;


                .option-label {
                    margin-top: initial;
                    margin-left: .75em;
                    display: block;
                }

                &:first-child {
                    border-bottom-left-radius: .5em;
                }

                &:last-child {
                    border-right: none;
                    border-bottom-right-radius: .5em;
                }
            }
        }
    }
}

</style>